<template>
  <section class="py-12 bg-kannister-dark-50">
    <div class="section-container">
      <div class="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
        <!-- Metric 1 -->
        <div>
          <div class="text-3xl md:text-4xl font-bold text-kannister-blue-600">
            &lt; 40ms
          </div>
          <div class="mt-2 text-sm text-kannister-dark-600 font-medium">
            Performance overhead
          </div>
        </div>

        <!-- Metric 2 -->
        <div>
          <div class="text-3xl md:text-4xl font-bold text-kannister-blue-600">
            99.9%
          </div>
          <div class="mt-2 text-sm text-kannister-dark-600 font-medium">
            Uptime SLA
          </div>
        </div>

        <!-- Metric 3 -->
        <div>
          <div class="text-2xl md:text-3xl font-bold text-kannister-blue-600">
            SOC2 + ISO
          </div>
          <div class="mt-2 text-sm text-kannister-dark-600 font-medium">
            Compliance certified
          </div>
        </div>

        <!-- Metric 4 -->
        <div>
          <div class="text-3xl md:text-4xl font-bold text-kannister-blue-600">
            500+
          </div>
          <div class="mt-2 text-sm text-kannister-dark-600 font-medium">
            Enterprise teams
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
